

// import React, { useEffect, useState } from "react";
// import { Button, Modal } from "react-bootstrap";
// import { useNavigate, useLocation } from "react-router-dom";
// import Commonheader from "../CommonUtils/Commonheader";
// import "../index.css";
// import { IoHomeSharp, IoToggleOutline } from "react-icons/io5";
// import { MdEditDocument } from "react-icons/md";
// // import ChangePassword from "../ChangePassword";
// import { MenuItem } from "./ParentSection";

// export function MenuBar({ children }) {

//   const navigate = useNavigate();
//   const location = useLocation();

//   const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth > 768);

//   const [activeMenu, setActiveMenu] = useState(localStorage.getItem("ServiceName") || "home");

//   // ── FIX: only one parent section can be expanded at a time (accordion) ────
//   const [openParentId, setOpenParentId] = useState(null);

//   const menuData = JSON.parse(sessionStorage.getItem("menuData")) || [];
//   const isChanged = sessionStorage.getItem("is_changed");

//   const filtered = menuData.filter(
//     (item) =>
//       item.service_name?.toLowerCase() !== "home"
//   );
//   const sorted = [...filtered].sort(
//     (a, b) => (a.priority || 0) - (b.priority || 0)
//   );
//   const parents = sorted.filter((item) => item.parent_id === 0);
//   const kids = sorted.filter((item) => item.parent_id !== 0);

//   const getServiceNameFromPath = (pathValue) => {
//     if (!pathValue || pathValue === "home") return "home";
//     const normalized = decodeURIComponent(pathValue);
//     const matched = sorted.find(
//       (item) => String(item?.target || "") === normalized || String(item?.service_name || "") === normalized
//     );
//     return matched?.service_name || normalized;
//   };

//   const updateServiceName = (value) => {
//     localStorage.setItem("ServiceName", value);
//     window.dispatchEvent(new Event("ServiceNameChanged"));
//   };

//   const hasHierarchy = parents.length > 0 && kids.length > 0;

//   // If the user lands on bare "/" with no path, redirect to /home.
//   useEffect(() => {
//     const path = location.pathname.replace("/", "");
//     if (!path) {
//       navigate("/home", { replace: true });
//     }
//   }, []);

//   // ── Keep activeMenu highlight in sync with URL (back/forward/reload) ──────
//   useEffect(() => {
//     const path = location.pathname.replace("/", "") || "home";
//     const serviceName = getServiceNameFromPath(path);
//     setActiveMenu((prev) => (prev === serviceName ? prev : serviceName));
//     if (localStorage.getItem("ServiceName") !== serviceName) {
//       updateServiceName(serviceName);
//     }
//   }, [location.pathname, sorted]);

//   // ── FIX: auto-expand whichever parent contains the active child, and make
//   //    sure it's the ONLY one expanded ─────────────────────────────────────
//   useEffect(() => {
//     const activeParent = parents.find((p) =>
//       kids.some((k) => k.parent_id === p.service_id && k.service_name === activeMenu)
//     );
//     setOpenParentId(activeParent ? activeParent.service_id : null);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [activeMenu]);

//   const handleToggleParent = (serviceId) => {
//     setOpenParentId((prev) => (prev === serviceId ? null : serviceId));
//   };

//   useEffect(() => {
//     const onResize = () => setSidebarOpen(window.innerWidth > 768);
//     window.addEventListener("resize", onResize);
//     return () => window.removeEventListener("resize", onResize);
//   }, []);

//   const [routeKey, setRouteKey] = useState(0);

//   // ── Clicking the same menu item forces child component to remount ─────────
//   const handleSelect = (targetPath) => {
//     const finalPath = String(targetPath || "home").replace(/^\/+/, "");
//     const finalServiceName = getServiceNameFromPath(finalPath);

//     setActiveMenu((prev) => (prev === finalServiceName ? prev : finalServiceName));
//     if (localStorage.getItem("ServiceName") !== finalServiceName) {
//       updateServiceName(finalServiceName);
//     }

//     if (location.pathname === `/${finalPath}`) {
//       // Already on this path — bump key to force remount of children
//       setRouteKey((k) => k + 1);
//     } else {
//       navigate(`/${finalPath}`);
//     }

//     // Close the sidebar drawer automatically on mobile after navigating
//     if (window.innerWidth <= 768) {
//       setSidebarOpen(false);
//     }
//   };

//   const [modal, setModal] = useState(false);

//   if (!menuData.length) return null;

//   // ── Build menu items ──────────────────────────────────────────────────────
//   const menuItems = hasHierarchy
//     ? parents.map((parent) => ({
//       item: parent,
//       kids: kids
//         .filter((c) => c.parent_id === parent.service_id)
//         .sort((a, b) => (a.priority || 0) - (b.priority || 0)),
//     }))
//     : sorted.map((item) => ({ item, kids: [] }));

//   return (
//     <>
//       <Commonheader />

//       {/* Backdrop for the mobile drawer — tapping it closes the sidebar */}
//       {sidebarOpen && window.innerWidth <= 768 && (
//         <div className="sidebar-backdrop" onClick={() => setSidebarOpen(false)} />
//       )}

//       <div className="dashboard-container vh-100">
//         <div className="main-area">
//           <aside className={`sidebar ${sidebarOpen ? "open" : "closed"}`}>

//             <Button
//               className="toggle-btn"
//               onClick={() => setSidebarOpen(!sidebarOpen)}
//             >
//               <IoToggleOutline size={25} />
//             </Button>

//             <ul className="sidebar-menu">

//               {/* Home - always shown */}
//               <li
//                 className={`single-menu home-menu ${activeMenu === "home" ? "active" : ""}`}
//                 role="button"
//                 tabIndex={0}
//                 onClick={() => handleSelect("home")}
//                 onKeyDown={(e) => {
//                   if (e.key === "Enter" || e.key === " ") {
//                     e.preventDefault();
//                     handleSelect("home");
//                   }
//                 }}
//               >
//                 <IoHomeSharp />
//                 {sidebarOpen && <span className="child-itemnew">Home</span>}
//               </li>

//               {/* Dynamic menu items */}
//               {menuItems?.map(({ item, kids }) => (
//                 <MenuItem
//                   key={item.service_id}
//                   item={item}
//                   kids={kids}
//                   activeMenu={activeMenu}
//                   onSelect={handleSelect}
//                   sidebarOpen={sidebarOpen}
//                   defaultIcon={MdEditDocument}
//                   isOpen={openParentId === item.service_id}
//                   onToggle={() => handleToggleParent(item.service_id)}
//                 />
//               ))}

//             </ul>

//             <div className="sidebar-footer">
//               <p className="mb-0">
//                 Powered By{" "}
//                 <a href="https://apcfss.in/" target="_blank" rel="noreferrer">
//                   <img src="../images/dashboard-footer.png" alt="" className="img-fluid" />
//                 </a>
//               </p>
//             </div>

//           </aside>

//           <main className="content-box">
//             <div className="inner-content" key={routeKey}>
//               {children}
//             </div>
//           </main>

//         </div>
//       </div>
//     </>
//   );
// }

// export default MenuBar;


import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import Commonheader from "../CommonUtils/Commonheader";
import "../index.css";
import { IoHomeSharp, IoToggleOutline } from "react-icons/io5";
import { MdEditDocument, MdMenu } from "react-icons/md";
import { MenuItem } from "./ParentSection";

export function MenuBar({ children }) {

  const navigate = useNavigate();
  const location = useLocation();

  const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth > 768);

  const [activeMenu, setActiveMenu] = useState(localStorage.getItem("ServiceName") || "home");

  // ── Only one parent section can be expanded at a time (accordion) ──────
  const [openParentId, setOpenParentId] = useState(null);

  const menuData = JSON.parse(sessionStorage.getItem("menuData")) || [];
  const isChanged = sessionStorage.getItem("is_changed");

  const filtered = menuData.filter(
    (item) =>
      item.service_name?.toLowerCase() !== "home"
  );
  const sorted = [...filtered].sort(
    (a, b) => (a.priority || 0) - (b.priority || 0)
  );
  const parents = sorted.filter((item) => item.parent_id === 0);
  const kids = sorted.filter((item) => item.parent_id !== 0);

  const getServiceNameFromPath = (pathValue) => {
    if (!pathValue || pathValue === "home") return "home";
    const normalized = decodeURIComponent(pathValue);
    const matched = sorted.find(
      (item) => String(item?.target || "") === normalized || String(item?.service_name || "") === normalized
    );
    return matched?.service_name || normalized;
  };

  const updateServiceName = (value) => {
    localStorage.setItem("ServiceName", value);
    window.dispatchEvent(new Event("ServiceNameChanged"));
  };

  const hasHierarchy = parents.length > 0 && kids.length > 0;

  // If the user lands on bare "/" with no path, redirect to /home.
  useEffect(() => {
    const path = location.pathname.replace("/", "");
    if (!path) {
      navigate("/home", { replace: true });
    }
  }, []);

  // ── Keep activeMenu highlight in sync with URL (back/forward/reload) ──────
  useEffect(() => {
    const path = location.pathname.replace("/", "") || "home";
    const serviceName = getServiceNameFromPath(path);
    setActiveMenu((prev) => (prev === serviceName ? prev : serviceName));
    if (localStorage.getItem("ServiceName") !== serviceName) {
      updateServiceName(serviceName);
    }
  }, [location.pathname, sorted]);

  // ── Auto-expand whichever parent contains the active child, and make
  //    sure it's the ONLY one expanded ─────────────────────────────────────
  useEffect(() => {
    const activeParent = parents.find((p) =>
      kids.some((k) => k.parent_id === p.service_id && k.service_name === activeMenu)
    );
    setOpenParentId(activeParent ? activeParent.service_id : null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeMenu]);

  const handleToggleParent = (serviceId) => {
    setOpenParentId((prev) => (prev === serviceId ? null : serviceId));
  };

  useEffect(() => {
    const onResize = () => setSidebarOpen(window.innerWidth > 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const [routeKey, setRouteKey] = useState(0);

  // ── Clicking the same menu item forces child component to remount ─────────
  const handleSelect = (targetPath) => {
    const finalPath = String(targetPath || "home").replace(/^\/+/, "");
    const finalServiceName = getServiceNameFromPath(finalPath);

    setActiveMenu((prev) => (prev === finalServiceName ? prev : finalServiceName));
    if (localStorage.getItem("ServiceName") !== finalServiceName) {
      updateServiceName(finalServiceName);
    }

    if (location.pathname === `/${finalPath}`) {
      // Already on this path — bump key to force remount of children
      setRouteKey((k) => k + 1);
    } else {
      navigate(`/${finalPath}`);
    }

    // Close the sidebar drawer automatically on mobile after navigating
    if (window.innerWidth <= 768) {
      setSidebarOpen(false);
    }
  };

  const [modal, setModal] = useState(false);

  if (!menuData.length) return null;

  // ── Build menu items ──────────────────────────────────────────────────────
  const menuItems = hasHierarchy
    ? parents.map((parent) => ({
      item: parent,
      kids: kids
        .filter((c) => c.parent_id === parent.service_id)
        .sort((a, b) => (a.priority || 0) - (b.priority || 0)),
    }))
    : sorted.map((item) => ({ item, kids: [] }));

  return (
    <>
      <Commonheader />

      {/* Backdrop for the mobile drawer — tapping it closes the sidebar */}
      {sidebarOpen && window.innerWidth <= 768 && (
        <div className="sidebar-backdrop" onClick={() => setSidebarOpen(false)}
          onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") setSidebarOpen(false); }} />
      )}

      <div className="dashboard-container second-dash">
        <div className="main-area1">
          <aside className={`sidebar ${sidebarOpen ? "open" : "closed"}`}>

            <Button
              className="toggle-btn"
              onClick={() => setSidebarOpen(!sidebarOpen)}
            >
              <MdMenu size={22} />
            </Button>

            <ul className="sidebar-menu">

              {/* Home - always shown */}
              <li
                className={`single-menu home-menu ${activeMenu === "home" ? "active" : ""}`}
                role="button"
                tabIndex={0}
                onClick={() => handleSelect("home")}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    handleSelect("home");
                  }
                }}
              >
                <IoHomeSharp />
                {sidebarOpen && <span className="child-itemnew">Home</span>}
              </li>

              {/* Dynamic menu items */}
              {menuItems?.map(({ item, kids }) => (
                <MenuItem
                  key={item.service_id}
                  item={item}
                  kids={kids}
                  activeMenu={activeMenu}
                  onSelect={handleSelect}
                  sidebarOpen={sidebarOpen}
                  defaultIcon={MdEditDocument}
                  isOpen={openParentId === item.service_id}
                  onToggle={() => handleToggleParent(item.service_id)}
                />
              ))}

            </ul>

            <div className="sidebar-footer">
              <p className="mb-0">
                Powered By
                <a href="https://apcfss.in/" target="_blank" rel="noreferrer">
                  <img src="../images/apcfss-logo-white.svg" alt="" className="apcfss-logo" />
                </a>
              </p>
            </div>

          </aside>

          <main className="content-box">
            <div className="inner-content" key={routeKey}>
              {children}
            </div>
          </main>

        </div>
      </div>
    </>
  );
}

export default MenuBar;